var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9724 5.36251C15.7299 5.1363 15.3498 5.14957 15.1236 5.39215L5.44165 15.7748L5.23254 19.5215L8.95553 19.0515L18.6375 8.6689C18.8637 8.42632 18.8504 8.04628 18.6079 7.82007L15.9724 5.36251ZM14.2451 4.57296C14.9238 3.84521 16.0639 3.8054 16.7916 4.48404L19.427 6.9416C20.1548 7.62024 20.1946 8.76034 19.516 9.48809L9.834 19.8707C9.64237 20.0762 9.38475 20.208 9.10596 20.2432L4.81095 20.7854C4.41606 20.8352 4.05552 20.5555 4.00567 20.1606C4.00022 20.1174 3.99869 20.0737 4.00112 20.0302L4.24236 15.7078C4.25801 15.4273 4.37154 15.1611 4.56318 14.9556L14.2451 4.57296Z",
    fill: "#1D79F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80707 14.8296C6.23606 15.7413 6.78782 16.5066 7.45982 17.1333C8.13175 17.7598 8.92955 18.2531 9.86042 18.6104C10.1701 18.7293 10.3247 19.0767 10.2058 19.3864C10.087 19.696 9.73958 19.8507 9.42992 19.7318C8.36498 19.323 7.43282 18.7505 6.64063 18.0117C5.84851 17.2731 5.20922 16.3802 4.72021 15.341L5.80707 14.8296Z",
    fill: "#1D79F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0286 11.2747L12.6362 7.17876L13.4554 6.30029L17.8478 10.3962L17.0286 11.2747Z",
    fill: "#1D79F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2ae1cb7baed93f04e6f757bb20e4be19.svg";
export { ForwardRef as ReactComponent };